export const generateId = (
  id: string,
  title: string,
  type: 'button' | 'panel',
): string => {
  return `${id}-${type}-${title}`;
};
